import { useToast } from 'vue-toastification/composition';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

const useAccountTransaction = () => {
  const BANK_TRANSFER_ID = 1;
  const CASH_ID = 2;

  const toast = useToast();

  const createTransaction = async (transaction) => {
    try {
      return store.dispatch('accountTransaction/create', transaction);
    } catch (error) {
      console.error(error);
      toast.error({
        component: ToastificationContent,
        props: {
          title: 'Error creating the transaction',
          icon: 'XCircleIcon',
        },
      });
      return null;
    }
  };

  const fetchTransactionStatus = async () => {
    try {
      return await store.dispatch('accountTransaction/getTransactionStatus');
    } catch (error) {
      toast.error({
        component: ToastificationContent,
        props: {
          title: 'Error fetching the transaction status',
          icon: 'XCircleIcon',
        },
      });
      return null;
    }
  };

  const fetchTransactionTypes = async () => {
    try {
      return await store.dispatch('accountTransaction/getTransactionTypes');
    } catch (error) {
      toast.error({
        component: ToastificationContent,
        props: {
          title: 'Error fetching the transaction types',
          icon: 'XCircleIcon',
        },
      });
      return null;
    }
  };

  const fetchTransactions = async (params) => {
    try {
      return await store.dispatch('accountTransaction/getTransactions', {
        params,
      });
    } catch (error) {
      toast.error({
        component: ToastificationContent,
        props: {
          title: 'Error fetching the transaction list',
          icon: 'XCircleIcon',
        },
      });
      return null;
    }
  };

  const fetchAccountTransactions = async (accountId, params) => {
    try {
      return await store.dispatch(
        'accountTransaction/getTransactionsByAccount',
        {
          accountId,
          params,
        }
      );
    } catch (error) {
      console.error(error);
      toast.error({
        component: ToastificationContent,
        props: {
          title: 'Error fetching the account transactions',
          icon: 'XCircleIcon',
        },
      });
      return null;
    }
  };

  const cancelTransaction = async (transactionId, description) => {
    try {
      await store.dispatch('accountTransaction/cancelTransaction', {
        transactionId,
        description,
      });
      return true;
    } catch (error) {
      toast.error({
        component: ToastificationContent,
        props: {
          title: 'An error occurred.',
          icon: 'XCircleIcon',
        },
      });
    }
  };

  const resolveTransactionStatusVariantAndIcon = (transactionStatus) => {
    if (transactionStatus.isPaid) return 'success';
    if (transactionStatus.isPending) return 'warning';
    return 'secondary';
  };

  const resolveTransactionTypeVariantAndIcon = (id) => {
    if (id === BANK_TRANSFER_ID)
      return { variant: 'success', icon: 'CheckIcon' };
    if (id === CASH_ID) return { variant: 'info', icon: 'DollarSignIcon' };
    return { variant: 'secondary', icon: 'XIcon' };
  };

  return {
    // Method
    createTransaction,
    fetchAccountTransactions,
    fetchTransactions,
    fetchTransactionStatus,
    fetchTransactionTypes,
    resolveTransactionStatusVariantAndIcon,
    resolveTransactionTypeVariantAndIcon,
    cancelTransaction,
  };
};

export default useAccountTransaction;
